import * as yup from 'yup';

export const ForgotPasswordFormSchema = yup.object().shape({
  email: yup
    .string()
    .email('Please enter valid email.')
    .required('This field is required.'),
});
